"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameSteamDataPlatformsToJSON = exports.OWGameSteamDataPlatformsFromJSONTyped = exports.OWGameSteamDataPlatformsFromJSON = void 0;
var runtime_1 = require("../runtime");
function OWGameSteamDataPlatformsFromJSON(json) {
    return OWGameSteamDataPlatformsFromJSONTyped(json, false);
}
exports.OWGameSteamDataPlatformsFromJSON = OWGameSteamDataPlatformsFromJSON;
function OWGameSteamDataPlatformsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'windows': !(0, runtime_1.exists)(json, 'windows') ? undefined : json['windows'],
        'mac': !(0, runtime_1.exists)(json, 'mac') ? undefined : json['mac'],
        'linux': !(0, runtime_1.exists)(json, 'linux') ? undefined : json['linux'],
    };
}
exports.OWGameSteamDataPlatformsFromJSONTyped = OWGameSteamDataPlatformsFromJSONTyped;
function OWGameSteamDataPlatformsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'windows': value.windows,
        'mac': value.mac,
        'linux': value.linux,
    };
}
exports.OWGameSteamDataPlatformsToJSON = OWGameSteamDataPlatformsToJSON;
